// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"e7173e9f","903":"ebd4d41c","959":"2f8c724a"}[chunkId] + ".chunk.js";
};